import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class Team extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({ hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchTeamDataApi()
                this.dialogClose();
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchTeamDataApi()
                this.dialogClose();
            }
        }];

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteTeamApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false, disabled: false });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchTeamDataApi()
            }
        }];


        this.state = {
            data: [{
                id: '',
                userEmail: '',
                role: [],
                value: 'apple',
                approved: '',
                deleteRow: false,
            }],
            disabled: false,
            emails: [],
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            showStore: false,
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            disableSave: false,
            disableAdd: false

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.approvedImageSrc = "./assets/images/approved.png";
        this.notApprovedImgSrc = "./assets/images/not_approved.png";
        this.roleVar = [];
    }

    notifyFailToCreate() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    addRow = () => {
        var teamController = this;
        if (teamController.state.pageNum != 0) {
            teamController.setState({ pageNum: 0 })
        }
        var stateObj = this.state;
        stateObj.data.unshift({
            id: "",
            userEmail: "",
            role: this.roleVar
        });
        this.state.disabled = true;
        this.setState(this.state);
    }

    saveTeamApi(props, e) {
        props.original.userEmail = document.getElementById("userEmail" + props.index).innerText;
        props.original.role = document.getElementById("role" + props.index).value;
        this.state.editedId = '-1';
        this.setState(this.state);
        var validateResult = this.validateCells(props.original.userEmail, props.original.role);
        if (validateResult == true) {
            var updatedData = {
                emailId: props.original.userEmail,
                projectId: localStorage.getItem("currentProjectId"),
                userRole: props.original.role,

            };
            var addTeamController = this;
            $.ajax({
                url: "/api/project-membership-by-email",
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: updatedData,
                success: function (res) {
                    if (res.success === true) {
                        if (res.result == "done.") {
                            addTeamController.notifyAdded();
                            addTeamController.fetchTeamDataApi();
                            addTeamController.setState({ disabled: false })
                        }
                        else {

                            addTeamController.notifyAddedData(res.result);
                            addTeamController.fetchTeamDataApi();
                            addTeamController.setState({ disabled: false })
                        }
                    }
                    else {
                        if (res.result == null) {
                            addTeamController.notifyFailedToAdd();
                            addTeamController.setState({ disabled: false })
                        }
                        else {
                            addTeamController.notifyWarning(res.result);
                            addTeamController.setState({ disabled: false })
                        }

                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }

            })
        }
    }

    notifyAddedData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
        });
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyFailedResponseForAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }
    notifyFailedToAdd() {
        toast.dismiss();
        toast(<b>Oops! failed to add member</b>, {
            position: "top-center",
            color: "red"

        });
    }
    updateTeamApi(props, e) {
        this.state.data[props.index].userEmail = document.getElementById("userEmail" + props.index).innerText;
        this.state.data[props.index].role = document.getElementById("role" + props.index).value;
        var validateResult = this.validateCells(props.original.userEmail, props.original.role);
        if (validateResult == true) {
            var addedData = {
                userEmail: this.state.data[props.index].userEmail,
                role: this.state.data[props.index].role,
            };
            var updatedData = {
                id: this.state.data[props.index].id,
                projectId: localStorage.getItem("currentProjectId"),

                userId: this.state.data[props.index].userId,
                userName: this.state.data[props.index].userName,
                userEmail: this.state.data[props.index].userEmail,
                role: this.state.data[props.index].role,
            };
            var updatedDataController = this
            $.ajax({
                url: "/api/project-membership",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(updatedData),
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.notifyUpdate();
                    } else {
                        if (res.result == null) {
                            updatedDataController.notifyFailedToUpdate();
                        } else {
                            updatedDataController.notifyFailedResponse(res.result);
                        }
                    }
                    updatedDataController.setState({ editedId: -1 })
                    updatedDataController.fetchTeamDataApi();
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }

            })
        }
    }

    notifyFailedToUpdate() {
        toast.dismiss();
        toast(<b>Oops! failed to update</b>, {
            position: "top-center",
            color: "red"

        });
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id, props);
    }

    markAsBeingEdited(id, props) {

        this.state.editedId = id;
        this.state.disableSave = false;
        var stateObj = this.state;
        this.setState(stateObj);

    }
    deleteTeamApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true, disabled: false });
            deleteRowViewController.splice(id, 1);
        } else {
            $.ajax({
                url: "/api/project-membership/" + id,
                async: false,
                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {
                    if (res.success === true) {
                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false, disabled: false });
                        deleteConstructorVariables.notifyDelete();
                        deleteRowViewController.splice(id, 1);

                    } else {
                        deleteConstructorVariables.setState({ hideDeletePopup: false, disabled: false });
                        deleteConstructorVariables.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }

            });
        }
        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchRolesApi();
        deleteConstructorVariables.fetchTeamDataApi();

    }
    componentDidMount() {
        setTimeout(() => {
            this.fetchRolesApi();
            this.fetchTeamDataApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.state.disabled = false;
            thisController.projectId = event.projectId;
            thisController.fetchRolesApi(event.projectId);
            thisController.fetchTeamDataApi(event.projectId);
        });
    }

    validateCells(userEmail) {
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        if ((userEmail == "")) {
            this.notifyEmptyFields();
            return false;
        } else if (!pattern.test(userEmail)) {
            this.notifyWarning("Please enter valid Email ID");
        } else {
            return true;
        }

    }
    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill user email field</b>, {
            position: "top-center"
        });
    }

    notifyWarning(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchTeamDataApi()
        this.setState({ disabled: false })
    }
    fetchRolesApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var roleController = this;
        $.ajax(
            {
                url: "/api/project-roles",
                async: false,
                method: 'GET',
                data: {
                    projectId: projectId,
                },
                headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {
                    if (res.success === true) {
                        var roles = res.result;
                        roleController.state.data.role = roles
                        var numberOfroles = roles.length;
                        var ele3 = document.getElementById("role");
                        roleController.roleVar = [];
                        for (var i = 0; i < numberOfroles; i++) {
                            roleController.roleVar.push({
                                "code": roles[i]["code"],
                                "name": roles[i]["name"]
                            });
                        }
                        roleController.roleVar = roleController.roleVar.filter(role => role.code != "ROOT_ADMIN")
                        roleController.roleVar = roleController.roleVar.filter(role => role.code != "ACCOUNTANT")
                        roleController.roleVar = roleController.roleVar.filter(role => role.code != "PROJECT_SUPPORT_USER")
                        roleController.roleVar = roleController.roleVar.filter(role => role.code != "BUSINESS_ADMIN");
                        roleController.roleVar = roleController.roleVar.filter(role => role.code != "PROJECT_CHAT_HANDLE");
                        roleController.roleVar = roleController.roleVar.filter(role => role.code != "SERVICE_ENGINEER");
                        roleController.setState(roleController.state);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }


            }
        )
    }
    fetchTeamDataApi = (projectId) => {
        var teamController = this;
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        $.ajax({
            url: "/api/project-membership-dev-team",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,

            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

            success: function (res) {
                if (res.success === true) {
                    var domains = res.result;
                    teamController.setState({
                        data: domains,
                        successResp: true,
                        disabled: false,

                    });

                    var disableSave = true;
                    for (var i = 0; i < res.result.length; i++) {
                        if (res.result[i].role == "PROJECT_ADMIN" && res.result[i].userEmail == JSON.parse(localStorage.getItem("user_details"))["emailId"]) {
                            disableSave = false;
                        }
                    }
                    if (disableSave) {
                        teamController.state.disableSave = true;
                        teamController.state.disableAdd = true;
                    } else {
                        teamController.state.disableSave = false;
                        teamController.state.disableAdd = false;
                    }
                    teamController.setState(teamController);
                } else {
                    teamController.notifyFailToCreate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    handleEmailChange = (e) => {
        this.cursor = e.target.selectionStart;
        this.setState({ selectValue: e.target.value });
    }
    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Added Successfully</b>, {
            position: "top-center",
        });
    }
    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Updated Successfully</b>, {
            position: "top-center",
        });
    }
    notifyUpdateNotPossible(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;User deleted successfully</b>, {
            position: "top-center",
        });
    }
    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    render() {
        const { data } = this.state
        this.columns = [
            {
                Header: () => <b>User Email</b>,
                accessor: 'userEmail',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                width:700,
                Cell: props => (
                    <div name="userEmail">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"userEmail" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                            >
                            {props.original.userEmail}
                        </div>
                    </div>)
            }, {
                Header: <b>Role</b>,
                textAlign: 'screenLeft',
                accessor: 'role',
                sortable: false,
                headerStyle: { marginLeft: '10px' },
                Cell: props => {
                    return (
                        <div className="container-fluid" style={{ textAlign: "center" }}>
                            <select className="input-group form-control select2 "
                                tabIndex={-1} aria-hidden="true"
                                name="role"
                                style={{ marginLeft: '2px', background: 'white', border: 'none', width: '60%' }}
                                id={"role" + props.index}
                                disabled={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.userEmail}
                                {this.roleVar.map((role) => <option key={role}
                                    value={role.code} selected={props.original.role == role.code}>{role.name}</option>)}
                            </select>
                        </div>
                    )
                },
            },
            {
                Header: <b>Approved</b>,
                accessor: 'approved',
                sortable: false,
                headerStyle: { textAlign: 'center' },
                width:100,
                Cell: props => {
                    return (
                        <div Align="center">
                            <img className="img-responsive"
                                hidden={(props.original.id == "") ? true : false}
                                src={(props.original.approved == true) ? this.approvedImageSrc : this.notApprovedImgSrc} />
                        </div>
                    )
                },
            },


            {
                Header: <b>Action</b>,
                accessor: 'action',
                filterable: false,
                flexGrow: 1,
                width:100,
                sortable: false,
                headerStyle: { textAlign: 'center' },
                Cell: props => (
                    <div id="action" style={{ marginLeft: '20px' }}>

                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-10px', marginLeft: '-12px', opacity: (this.state.disableSave) ? 0.65 : 1 }} disabled={this.state.disableSave} onClick={(e) => {
                            (props.original.id == "") ? this.saveTeamApi(props, e) : (props.original.id == this.state.editedId) ?
                                this.updateTeamApi(props, e) : this.makeCelledit(props, e);
                        }} >
                            <img className="img-responsive"
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}

                            />
                        </button>

                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-10px', marginLeft: '0px', opacity: (this.state.disableSave) ? 0.65 : 1 }} title="Delete" disabled={this.state.disableSave} onClick={() => (props.original.id) === '' ?
                            this.fetchTeamDataApi() :
                            this.setState({
                                hideDeletePopup: true, deletePropIndex: props.index,
                                propsId: props.original.id
                            })}>
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}

                            /></button>
                    </div>
                ),

            },
        ]


        return (
            <div><Loader
                type="TailSpin"
                color="#282a65"
                visible={(this.state.successResp) ? false : true}
                height={300}
                width={50}

                style={{ textAlign: 'center' }}
            />
                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }}>
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    {/*links for css files used for popup */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    {/* <link rel="stylesheet" href="./assets/css/react-table-height.css" /> */}
                    <div className="wrapper" style={{ marginTop: "-20px" }}>
                        <div className="row" style={{ marginLeft: "2px", marginTop: '-15px' }}>
                            <div className="col-sm-5" >
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '35px' }}>Development Team</h6>
                            </div>
                            {/* Add button */}
                            <div className="col-sm-7 p-0">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <div className="p-2">
                                        <button className="btn action-button" title="Add"
                                            id="addMsg"
                                            onClick={this.state.disabled ? this.notifyEmptyFields : this.addRow.bind(this)}
                                            disabled={this.state.disableAdd}>
                                            <img src="./assets/images/add_white_24dp.png" />
                                        </button>
                                        <button className="btn action-button" onClick={this.refreshData} type="button" title="Refresh" >
                                            <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                        <div className="container-fluid">
                                            <div className="card-body p-0">
                                                <div className="card-body p-0">
                                                    <div id="example2_wrapper" className="dataTables_wrapper container-fluid dt-bootstrap4 p-0">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {/* left Menu start here*/}
                        {/* Content Header (Page header) */}
                        {/* /.content-header */}
                        {/* Custom Tabs */}
                        <div className="content">
                            <div className="container-fluid">
                                <div className="row" style={{ marginTop: '1%' }}>
                                    <div className="col-lg-12 ">
                                        <div className="card">
                                            <ReactTable
                                                data={data}
                                                columns={this.columns}
                                                defaultPageSize={10}
                                                pageSizeOptions={[5, 10, 15]}
                                                onPageChange={this.onPageChange}
                                                page={this.state.pageNum}
                                            />
                                        </div>
                                        <ToastContainer className="Toast-at-center" />
                                        {/*Dialog Component For Deletion Confirmation*/}
                                        <DialogComponent width='400px' animationSettings={this.settings}
                                            header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog}
                                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                content="" />&nbsp;Do you want to delete the user ?<br />
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }


}

export default Team


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/team/Team.js